import { mutator } from 'satcheljs';
import { getSharedFolderUserEmails } from '../selectors/getSharedFolderUserEmails';
import { removeSharedFolderUserEmail } from '../actions/removeSharedFolderUserEmail';
import { trace } from 'owa-trace';

/**
 * Mutator that removes the shared folder user email
 */
export default mutator(removeSharedFolderUserEmail, actionMessage => {
    let sharedFolderUserEmails = getSharedFolderUserEmails(actionMessage.userIdentity);
    const index = sharedFolderUserEmails.indexOf(actionMessage.sharedUserMailboxSmtpAddress);
    if (index !== -1) {
        sharedFolderUserEmails.splice(index, 1);
    } else {
        trace.error(
            'Trying to remove a non-existent shared folder user : ' +
                actionMessage.sharedUserMailboxSmtpAddress
        );
    }
});
